import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { EconomicAreaScatterWidget } from '../widgets/EconomicAreaScatterWidget'
import { useEconomicRiskQueryParams } from '../../../hooks/useEconomicRiskQueryParams'
import { useProfileAnalysisFilters } from '../../../hooks/useProfileAnalysisFilters'
import { EconomicHazardsWidget } from '../widgets/EconomicHazardsWidget'
import { EconomicSectorWidget } from '../widgets/EconomicSectorWidget'
import type { PropertiesMetricOption } from '../../../types/riskProfileProperties.types'
import { EconomicAreaWidget } from '../widgets/EconomicAreaWidget'

type EntityView = 'employers' | 'employees'

export function EconomicAnalysis() {
  const [entityView, setEntityView] = useState<EntityView>('employers')
  const {
    selectedWorkspace,
    areaGroup,
    areas,
    selectedHazardGroups,
    damageStates,
    selectedAreaTypesLabel,
  } = useProfileAnalysisFilters()

  const economicQueryParams = useEconomicRiskQueryParams({
    selectedWorkspace,
    areaGroup,
    areas,
    selectedHazardGroups,
    damageStates,
    entityView,
  })

  const metricOption: PropertiesMetricOption = {
    value: entityView,
    metric: entityView,
    type: 'total',
    label: entityView === 'employers' ? 'Employers disrupted' : 'Employees disrupted',
  }

  const hasAreaContext = areaGroup !== '' || areas.length > 0

  return (
    <div className="space-y-5">
      <Tabs value={entityView} onValueChange={(value) => setEntityView(value as EntityView)}>
        <TabsList>
          <TabsTrigger value="employers">Employers</TabsTrigger>
          <TabsTrigger value="employees">Employees</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <EconomicSectorWidget
          queryParams={economicQueryParams}
          metricOption={metricOption}
          entityNoun={entityView}
        />
        <EconomicHazardsWidget
          queryParams={economicQueryParams}
          metricOption={metricOption}
          entityNoun={entityView}
        />
        <EconomicAreaScatterWidget
          queryParams={economicQueryParams}
          metricOption={metricOption}
          entityNoun={entityView}
        />
        {hasAreaContext && (
          <EconomicAreaWidget
            queryParams={economicQueryParams}
            metricOption={metricOption}
            entityNoun={entityView}
            selectedAreaTypesLabel={selectedAreaTypesLabel}
          />
        )}
      </div>
    </div>
  )
}
